import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { NavItem, NavItemChildren } from '../interfaces/nav-item';
import { ApiService } from 'src/app/services/api.service';
import { ServerTypes } from 'src/app/models/servers';
import { requests } from 'src/app/models/requests';
import { share, tap } from 'rxjs/operators';
import { CoreStorageEnum } from 'src/app/models/core-storage.enum';
import { AuthService } from 'src/app/services/auth.service';
import { ClientResources } from 'src/environments/clientResources'
import { ClientResource, ClientResourceComponent, ClientResourcePage } from 'src/app/interfaces/client-resources';

@Injectable({
  providedIn: 'root',
})
export class ApplicationService {
  private navItems: BehaviorSubject<NavItem[]> = new BehaviorSubject<NavItem[]>(
    []
  );
  public navItems$: Observable<NavItem[]>;

  constructor(
    private http: HttpClient,
    private apiService: ApiService,
    private authService: AuthService
  ) {
    this.navItems$ = this.navItems.asObservable();
  }

  private get url(): string {
    return this.apiService.getCurentServer(ServerTypes.auth);
  }

  // The ptdesk host the menu and application lists are fetched from. Fixed
  // for every build (not the `ptdesk` entry handed out at login).
  private static readonly PTDESK_URL =
    'https://app-bo-ptdesk-01-egdfhkhfekg7asdm.swedencentral-01.azurewebsites.net';

  public getNavItems(): Observable<NavItem[]> {
    const headers = new HttpHeaders().set(
      'Authorization',
      this.authService.getTokenType() + ` ${this.authService.getAuthToken()}`
    );
    return this.http
      .get<NavItem[]>(`${ApplicationService.PTDESK_URL}/resources/menus`, { headers })
      .pipe(share());
  }

  public getApplicationItems(): Observable<NavItemChildren[]> {
    const headers = new HttpHeaders().set(
      'Authorization',
      this.authService.getTokenType() + ` ${this.authService.getAuthToken()}`
    );
    return this.http
      .get<NavItemChildren[]>(`${ApplicationService.PTDESK_URL}/applications/users/applications`, {
        headers,
      })
      .pipe(share());
  }

  public changeApplication(applicationId: string): Observable<any> {
    return this.http
      .put(`${this.apiService.getCurentServer(ServerTypes.auth)}/v1/auth/token/applications/${applicationId}`, {
        headers: this.apiService.getHeaders(ServerTypes.auth, 0),
      })
      .pipe(
        tap((res) => {
            localStorage.setItem(CoreStorageEnum.clientId, applicationId);
            localStorage.setItem(ServerTypes.boapi, res.url);
            localStorage.setItem(CoreStorageEnum.tokenName, res.access_token);      
            res.servers.forEach(server => {
              localStorage.setItem(server.name, server.url);
            })
        })
      );
  }

  public getAllApplicationResources(): ClientResource {
    var clientId = parseInt(localStorage.getItem(CoreStorageEnum.clientId).substring(0,4));
    var def = ClientResources.filter(q => q.clientId === 0)[0]
    var resource = ClientResources.filter(q => q.clientId === clientId)[0];
    return resource;
  }

  public getPage(page:string, id:string): ClientResourcePage {
    var clientId = parseInt(localStorage.getItem(CoreStorageEnum.clientId).substring(0,4));
    var defaultpages = ClientResources.filter(q => q.clientId === 0)[0].pages;
    var current = ClientResources.filter(q => q.clientId === clientId);
    var currentPages = current.length != 0 ? current[0].pages : currentPages = [];

    var result = currentPages.filter(q => q.page == page && q.id == id)[0];
    if (result === undefined) result = defaultpages.filter(q => q.page == page)[0];
  
    return result;
  }

  
  public getPageComponent(page:string, component: string): ClientResourceComponent {
    var clientId = parseInt(localStorage.getItem(CoreStorageEnum.clientId).substring(0,4));
    var defaultpages = ClientResources.filter(q => q.clientId === 0)[0].pages;
    var current = ClientResources.filter(q => q.clientId === clientId);
    var currentPages = current.length != 0 ? current[0].pages : currentPages = [];

    var result = currentPages.filter(q => q.page == page)[0] as ClientResourcePage;
    if (result === undefined) result = defaultpages.filter(q => q.page == page)[0] as ClientResourcePage;
  
    var componentResult = result.content.filter(q => q.component == component)[0];
    return componentResult;
  }



  // updateNavItems(items: NavItem[]): void {
  //   this.navItems.next(items);
  // }
}
